export function shiftMonthSafe(sourceDate, delta) {
    const date = new Date(sourceDate);
    const day = date.getDate();

    date.setDate(1);
    date.setMonth(date.getMonth() + delta);

    const lastDayOfMonth = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0,
    ).getDate();

    date.setDate(Math.min(day, lastDayOfMonth));

    return date;
}

export function shiftYearSafe(sourceDate, delta) {
    const date = new Date(sourceDate);
    const month = date.getMonth();
    const day = date.getDate();

    date.setDate(1);
    date.setFullYear(date.getFullYear() + delta);
    date.setMonth(month);

    const lastDayOfMonth = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0,
    ).getDate();

    date.setDate(Math.min(day, lastDayOfMonth));

    return date;
}
